import { render, staticRenderFns } from "./change-phone-submit.vue?vue&type=template&id=796815c8&scoped=true&"
import script from "./change-phone-submit.vue?vue&type=script&lang=js&"
export * from "./change-phone-submit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796815c8",
  null
  
)

export default component.exports